// Only the rows whose manual time changed are sent; an empty value clears the saved time.
export function buildMeunerieManualTimeChanges(initialTimes = {}, draftTimes = {}) {
  const changes = {};
  Object.keys({ ...initialTimes, ...draftTimes }).forEach((rowKey) => {
    const nextValue = (draftTimes[rowKey] || "").trim();
    if (nextValue !== (initialTimes[rowKey] || "").trim()) {
      changes[rowKey] = nextValue;
    }
  });
  return changes;
}
